import { render, staticRenderFns } from "./PopoverMenu.vue?vue&type=template&id=1c5cc368&scoped=true&"
import script from "./PopoverMenu.vue?vue&type=script&lang=js&"
export * from "./PopoverMenu.vue?vue&type=script&lang=js&"
import style0 from "./PopoverMenu.vue?vue&type=style&index=0&id=1c5cc368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5cc368",
  null
  
)

export default component.exports